import { CosService } from '@/apis';

/** 接口返回的 data 可能是 string[] 或 { url: string; name?: string }[] */
function parseUploadResponseData(d: unknown): string[] {
  if (!d || !Array.isArray(d)) return [];
  return d.map((item) => {
    if (typeof item === 'string') return item;
    if (item && typeof item === 'object' && 'url' in item && typeof (item as { url: string }).url === 'string') {
      return (item as { url: string }).url;
    }
    return '';
  }).filter(Boolean);
}

/** 使用 COS 上传接口上传文件，返回 URL 列表（与产品图片上传同一接口） */
export async function uploadFile(file: File): Promise<string[]> {
  const res = await CosService.cosControllerCosUpload({ file: file as Blob });
  const d = (res as { data?: unknown })?.data;
  const urls = parseUploadResponseData(d);
  if (urls.length > 0) return urls;
  throw new Error('上传返回为空');
}
